import { connect } from 'react-redux'

import { getNote } from 'data/notes/selectors'
import { getActiveTemplateId } from 'data/ui/selectors'
import { currentUserCanEditNote } from 'data/rights/selectors'
import { getActiveChannel } from 'data/channels/selectors'
import { setActiveModal } from 'data/ui/actions'
import { CHANNEL_SETTINGS } from 'components/Utils/Modal/constants'

export default connect(
  (state, { noteId }: { noteId: string }) => {
    const note = getNote(state, noteId)
    const templateId = getActiveTemplateId(state)
    const channel = getActiveChannel(state)
    const readOnly = note && !currentUserCanEditNote(state, note)
    const isArchived = note && Boolean(note.archivedAt)
    const isPublic =
      (note && Boolean(note.publiclySharedAt)) ||
      (channel && Boolean(channel.publiclySharedAt))

    return {
      templateId,
      readOnly,
      isArchived,
      isPublic,
      isChannel: !note || !note.publiclySharedAt,
      channelId: channel ? channel.id : null,
      noteId: note ? note.id : null,
    }
  },
  { setActiveModal },
  (
    { isChannel, isPublic, channelId, noteId, ...otherProps },
    { setActiveModal },
    ownProps
  ) => ({
    ...ownProps,
    ...otherProps,
    isChannel,
    isPublic,
    onPublicBadgeClick:
      isPublic && isChannel
        ? () =>
            setActiveModal({
              id: CHANNEL_SETTINGS,
              meta: {
                channelId,
                defaultTabId: 'sharing',
              },
            })
        : undefined,
  })
)
